<template>
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M33.75 20L3.75 20"
            stroke="black"
            stroke-width="3.5"
            stroke-linecap="round"
        />
        <path
            d="M26.25 10L35.0126 18.7626C35.696 19.446 35.696 20.554 35.0126 21.2374L26.25 30"
            stroke="black"
            stroke-width="3.5"
            stroke-linecap="round"
        />
    </svg>
</template>
